import React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { Row } from "reactstrap";
import { useTranslate } from "hooks";
import { ProductBreadcrumb } from "components/ProductConfigurator/components/Breadcrumb/ProductBreadcrumb";
import s from "./ProductsOverview.module.scss";
import { ProductsOverviewSearch } from "./ProductsOverviewSearch";
import type { NiceModalHandler } from "@ebay/nice-modal-react";

type ProductsOverviewHeaderProps = {
  isModalActive?: boolean;
  title: React.ReactNode;
  infoText?: string;
  handleBackAction?: () => void;
  id?: string;
  dummy?: string;
  wizardType?: string;
  modal?: NiceModalHandler<Record<string, unknown>>;
};

export const ProductsOverviewHeader = Scrivito.connect(
  ({
    isModalActive,
    title,
    infoText,
    handleBackAction,
    id,
    dummy,
    wizardType,
    modal,
  }: ProductsOverviewHeaderProps) => {
    const translate = useTranslate();

    return (
      <Row
        className={cx(s.headerProducts, "p-5 pb-0 sticky-top bg-gray-100 z-1", {
          "px-3": infoText,
          "bg-white": isModalActive,
        })}
      >
        <div
          className={cx("d-flex justify-content-between", s.headerFirstLine)}
        >
          <h3 className="text-uppercase">{title}</h3>

          {!infoText && (
            <ProductsOverviewSearch
              isModalActive={isModalActive ?? false}
              handleBackAction={handleBackAction}
              id={id}
              dummy={dummy}
              wizardType={wizardType}
              modal={modal}
            />
          )}
        </div>

        {isModalActive && <h4>{translate("WIZARD_PRODUCT_SERIES")}</h4>}
        {!isModalActive && <ProductBreadcrumb />}
      </Row>
    );
  },
);
